import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "@/api/client";

interface ModeEvaluationRequest {
  sensor_kit_serial_number: string
  start_time: string
  end_time: string
  assumed_mode?: string
}

export interface RuleEvaluation {
  rule_name: string
  satisfied: boolean
  margin: number
  confidence: number
  explanation: string
  is_violation: boolean
  evidence_type?: string
  target_modes?: string[]
  weight?: number
}

export interface Sensor {
  display_name: string
  temperature_sensor_input_number?: number
}

export interface EvaluatedSensor {
  sensor: Sensor
  evaluated_rules: RuleEvaluation[]
  has_violations: boolean
}

interface ModeEvaluationResponse {
  detected_mode: string
  assumed_mode?: string
  mode_scores: Record<string, number>
  evaluated_rules: RuleEvaluation[]
  evaluated_sensors: EvaluatedSensor[]
  violated_rules: string[]
  compliant_rules: string[]
  summary?: string
}

const evaluateMode = async (data: ModeEvaluationRequest): Promise<ModeEvaluationResponse> => {
  const response = await apiClient.post<ModeEvaluationResponse>('/mode-evaluation/', data)
  return response.data
}
export const useModeEvaluation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: evaluateMode,
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ['installations', variables.sensor_kit_serial_number]
      })
    },
    onError: (error) => {
      console.error('Mode evaluation failed:', error)
    }
  })
}